
import crud from "./_crud";
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud('department', 'el departamento', 'los departamentos');

const importDepartments = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/department/import_departments`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			successMessage: `Se agregaron los departamentos correctamente.`,
		})
		showSuccessMessage('Se registraron los departamentos correctamente.')
		return res.body
	}
}

export default {...actions, importDepartments}